// extracted by mini-css-extract-plugin
export default {"main":"styles_main__5Hej8","img":"styles_img__1HuB1","text":"styles_text__6BrKG"};